import { Controller } from "@hotwired/stimulus"

// Listens for resize::<height> messages posted by the embedded Hapi
// Benefits claims form and resizes the iframe to fit its content.
export default class extends Controller {
  static targets = ["iframe"]

  connect() {
    this.boundHandleMessage = this.handleMessage.bind(this)
    window.addEventListener("message", this.boundHandleMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.boundHandleMessage)
  }

  handleMessage(event) {
    if (typeof event.data !== "string" || !event.data.includes("resize::")) return

    const height = event.data.replace("resize::", "")
    this.iframeTarget.style.height = `${height}px`
  }
}
